import { render } from "./BranchMerchantSetup.vue?vue&type=template&id=027b70dc&scoped=true"
import script from "./BranchMerchantSetup.vue?vue&type=script&lang=js"
export * from "./BranchMerchantSetup.vue?vue&type=script&lang=js"

import "./BranchMerchantSetup.vue?vue&type=style&index=0&id=027b70dc&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-027b70dc"]])

export default __exports__